import { render, staticRenderFns } from "./FixedLeft.vue?vue&type=template&id=8ab2a588&scoped=true&"
import script from "./FixedLeft.vue?vue&type=script&lang=js&"
export * from "./FixedLeft.vue?vue&type=script&lang=js&"
import style0 from "./FixedLeft.vue?vue&type=style&index=0&id=8ab2a588&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2a588",
  null
  
)

export default component.exports